var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDetailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4 83.633L97 83.633 97 12.633 4 12.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#359EAD",
    d: "M0 12.633L99 12.633 99 0.633 0 0.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD8972",
    d: "M68 30.633L75 30.633 75 23.633 68 23.633zM79 30.633L86 30.633 86 23.633 79 23.633zM68 42.633L75 42.633 75 35.633 68 35.633zM79 42.633L86 42.633 86 35.633 79 35.633zM68 55.633L75 55.633 75 48.633 68 48.633zM79 55.633L86 55.633 86 48.633 79 48.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1BDBA",
    d: "M14 30.633L21 30.633 21 23.633 14 23.633zM25 30.633L32 30.633 32 23.633 25 23.633zM47 30.633L54 30.633 54 23.633 47 23.633zM58 30.633L65 30.633 65 23.633 58 23.633zM25 42.633L32 42.633 32 35.633 25 35.633zM35 42.633L42 42.633 42 35.633 35 35.633zM47 42.633L54 42.633 54 35.633 47 35.633zM58 42.633L65 42.633 65 35.633 58 35.633zM14 55.633L21 55.633 21 48.633 14 48.633zM25 55.633L32 55.633 32 48.633 25 48.633zM35 55.633L42 55.633 42 48.633 35 48.633zM58 55.633L65 55.633 65 48.633 58 48.633zM14 67.633L21 67.633 21 60.633 14 60.633zM35 67.633L42 67.633 42 60.633 35 60.633zM47 67.633L54 67.633 54 60.633 47 60.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M35 30.633L42 30.633 42 23.633 35 23.633zM14 42.633L21 42.633 21 35.633 14 35.633zM47 55.633L54 55.633 54 48.633 47 48.633zM25 67.633L32 67.633 32 60.633 25 60.633zM58 67.633L65 67.633 65 60.633 58 60.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD8972",
    d: "M68 67.633L75 67.633 75 60.633 68 60.633zM79 67.633L86 67.633 86 60.633 79 60.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M96.907 16.633L96.907 84.546 1 84.546 1 87.633 100 87.633 100 16.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "M100 87.633L1 87.633 1 84.546 96.907 84.546 96.907 16.633 100 16.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M0 16.633L0 81.633 93 81.633 93 78.538 3.1 78.538 3.1 16.633z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    d: "M93 81.633L0 81.633 0 16.633 3.1 16.633 3.1 78.538 93 78.538z",
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M48 9.633L52 9.633 52 5.633 48 5.633zM56 9.633L60 9.633 60 5.633 56 5.633zM39 9.633L43 9.633 43 5.633 39 5.633z",
    transform: "translate(0 12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDetailed);
export default __webpack_public_path__ + "static/media/CalendarDetailed.a5cb1e408073bb498f57cc6254f32922.svg";
export { ForwardRef as ReactComponent };